import { useEffect, useState } from "react";
import MarkdownIt from "markdown-it";

import { Layout } from "../../../components";
import { getPages } from "../api";


const RefundPolicy = () => {

  const [privacyPolicy, setPrivacyPolicy] = useState<string>('');


  const mdParser = new MarkdownIt({
    html: true,
    linkify: true,
    typographer: true,
  });

  useEffect(() => {
    getPages({type:7}).then(res => {
      setPrivacyPolicy(res.data.data.content);
    });
    window.scrollTo(0, 0);
  }, [])

  return (
    <Layout>
      <div className="container">
        <h3 className="text-center mt-5 mb-3">Refund Policy </h3>
        <div
          // className="mb-5"
          // dangerouslySetInnerHTML={{
          //   __html: mdParser.render(privacyPolicy),
          // }}
          
        />
        <h1>Refund Policy</h1>

<p>
  At TravelX, we are dedicated to delivering high-quality eSIM services and ensuring customer satisfaction. This Refund Policy outlines the conditions under which you may request a refund. You agree to comply with this policy by purchasing and using our services.
</p>

<h2>Eligibility for Refunds</h2>
<ol>
  <li>
    <strong>Service Activation Issues:</strong> If you experience problems activating your eSIM service, be sure to get in touch with our customer support team immediately. We will make every effort to resolve the issue. If the problem cannot be resolved within a reasonable time frame, you may be eligible for a full refund of the purchase price.
  </li>
  <li>
    <strong>Service Unavailability:</strong> If the eSIM service is unavailable or cannot be used in the specified coverage area due to technical issues beyond your control, you may be eligible for a full or partial refund, depending on the extent of the unavailability.
  </li>
  <li>
    <strong>Accidental Purchases:</strong> If you accidentally purchase an eSIM plan or select the wrong plan, you must contact us within 24 hours of the purchase to request a refund. Refunds for accidental purchases are subject to review and approval.
  </li>
</ol>

<h2>Non-Eligibility for Refunds</h2>
<ol start={2}>
  <li>
    <strong>Change of Mind:</strong> Refunds will not be granted if you change your mind or decide you no longer want to use the eSIM service after activation.
  </li>
  <li>
    <strong>Device Incompatibility:</strong> It is your responsibility to ensure that your device is unlocked and compatible with eSIM technology. Refunds will not be granted for issues arising from device incompatibility.
  </li>
  <li>
    <strong>Misuse or Violation:</strong> If you misuse the service or violate the terms and conditions of use, you will not be eligible for a refund. Misuse includes, but is not limited to, sharing the eSIM with unauthorized users or using the service unlawfully.
  </li>
</ol>

<h2>Refund Process</h2>
<ol start={3}>
  <li>
    <strong>Submitting a Request:</strong> To request a refund, you must submit a written request to our customer support team at <a href="mailto:support@travelx.ai">support@travelx.ai</a>. The request should include your order number, the reason for the refund, and any relevant details or evidence supporting your claim.
  </li>
  <li>
    <strong>Review and Approval:</strong> Upon receiving your refund request, our team will review it and may contact you for additional information. The review process typically takes 5-7 business days. Approval of refund requests is at the sole discretion of TravelX.
  </li>
  <li>
    <strong>Refund Method:</strong> If your refund request is approved, the refund will be processed using the original payment method. Refunds may take 7-10 business days to reflect in your account, depending on your payment provider.
  </li>
</ol>

<h2>Partial Refunds</h2>
<p>
  In certain circumstances, partial refunds may be issued. For example, if you have used a portion of your data plan but encounter a service issue, we may provide a partial refund based on the unused portion of the plan. Partial refunds will be calculated on a pro-rata basis.
</p>

<h2>Exceptional Cases</h2>
<p>
  In exceptional cases where the standard refund policy does not apply, we will handle refund requests on a case-by-case basis. This includes scenarios such as natural disasters, severe network outages, or other unforeseen events that may significantly impact the service.
</p>
      </div>
    </Layout>
  );
};

export default RefundPolicy;